import Axios from "axios";
import config from "configs/config";
import getText from "Translator";

const returnError = (err, lang) => {
  console.log(err);
  const data = {
    success: false,
    code: 5001,
    message: getText("generalerror", lang),
  };
  return data;
};
export const getReport = async (lang, condition, token) => {
  try {
    const url = config.apiserver + "/condition/getreport";

    let responce = await Axios.post(url, condition, {
      headers: {
        "x-access-token": token,
      },
    });
    console.log(responce.data);
    return responce.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const getConditionNew = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/condition/getconditionnew/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const storeConditionNew = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/condition/storeconditionnew/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};

export const updateConditionNew = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/condition/updateconditionnew/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const removeConditionNew = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/condition/removeconditionnew/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
export const updateConditionsRowNumbers = async (lang, newDatas, token) => {
  try {
    const url = config.apiserver + "/condition/updateConditionsRowNumbers/";
    console.log(url);
    let res = await Axios.post(url, newDatas, {
      headers: {
        "x-access-token": token,
      },
    });
    return res.data;
  } catch (err) {
    return returnError(err, lang);
  }
};
